import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, InputDropdownMultiSelectFilter } from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayListViewModel } from './DisplayListViewModel';
import { ServiceOption, ServiceOptions } from '../constants/serviceKit';

export interface IServiceLevelsFilterProps {
    readonly vm: DisplayListViewModel;
}

@observer
export class ServiceLevelsFilter extends React.Component<IServiceLevelsFilterProps> {
    public render() {
        const { onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="Service Levels"
                filter={this.filter}
                disabled={this.props.vm.disabledFilters.includes('serviceLevels')}
                options={this.options}
                style={{
                    minWidth: 400,
                }}
                print={this.print}
                onToggle={onFilterDropdownToggle}
                onChange={this.onChange}
                openOnMount
            />
        );
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    @bind
    @action
    private onChange(value: ServiceOption[] | undefined) {
        const { displayFilter } = this.props.vm;

        if (value != undefined) {
            displayFilter.contractServiceLevels = value
                .filter(s => s.type == 'serviceLevel')
                .map(s => s.value as Mri.Contracts.ServiceLevel);
        } else {
            displayFilter.contractServiceLevels = undefined;
        }
    }

    @computed
    private get filter() {
        const { displayFilter } = this.props.vm;
        if (!displayFilter.contractServiceLevels && !displayFilter.contractOptions) return;

        let filter: ServiceOption[] = [];

        const serviceLevels = displayFilter.contractServiceLevels
            ? (displayFilter.contractServiceLevels
                .map(s => this.options.find(o => o.value == s))
                .filter(s => s) as ServiceOption[])
            : [];

        filter = filter.concat(serviceLevels);

        return filter;
    }

    private print(entity: ServiceOption) {
        return entity.option;
    }

    private options = ServiceOptions;
}
